import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { Box, Typography } from '@mui/material';
import { optionCardSx, ChoiceError } from './RadioButtonsGroup';

export default function PaymentRadioButtons({
  resultSelected,
  setResultSelected,
  paymentOptions,
  error = false
}) {
  const handleValueChange = (event) => {
    let selectedValue = event.target.value;
    setResultSelected(selectedValue);
  };

  return (
    <FormControl fullWidth>
      <RadioGroup
        aria-label="Начин на плащане"
        name="payment-options"
        value={resultSelected}
        onChange={handleValueChange}>
        {paymentOptions.map((item) => {
          const selected = resultSelected === item.name;
          return (
            // The card wraps the label and its description so the explanation sits inside the
            // selected option rather than floating beneath the whole group.
            <Box key={item.name} sx={{ ...optionCardSx(selected, error), display: 'block', py: 1 }}>
              <FormControlLabel
                value={item.name}
                sx={{ m: 0, width: '100%' }}
                control={<Radio size="small" color={error ? 'error' : 'primary'} />}
                label={
                  <Typography sx={{ fontSize: 14, fontWeight: 600, color: 'text.primary' }}>
                    {item.name}
                  </Typography>
                }
              />
              {selected && item.description && (
                <Typography sx={{ pl: '38px', pr: 1, pb: 0.5, fontSize: 13, color: 'text.secondary' }}>
                  {item.description}
                </Typography>
              )}
            </Box>
          );
        })}
      </RadioGroup>
      {error && <ChoiceError message="Моля, изберете начин на плащане." />}
    </FormControl>
  );
}
